import React from 'react'

import { Box, Display, FlexDirection } from '@gousto-internal/citrus-react'

import { ParentCategory } from '@library/menu-page'

import { useSelectCollection } from 'hooks/menu-collections'
import { useParentCategories } from 'hooks/menu-parentcategories/useParentCategories'

export const BrowseScreen = () => {
  const parentCategories = useParentCategories()
  const selectCollection = useSelectCollection()

  return (
    <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={10}>
      {parentCategories.map(
        ({ id, categories, description, isLinkable, type, name, recipeCount }) => (
          <div key={id}>
            <ParentCategory
              id={id}
              categories={categories}
              description={description}
              isLinkable={isLinkable}
              type={type}
              name={name ?? ''}
              recipeCount={recipeCount}
              onCategoryClick={selectCollection}
            />
          </div>
        ),
      )}
    </Box>
  )
}
